import React from 'react';

import classnames from 'classnames';

import Button, { ButtonTypes } from 'common/components/core/Button/Button';
import Divider, { DividerAppearance } from 'common/components/core/Divider/Divider';
import FlexLayout from 'common/components/core/FlexLayout/FlexLayout';
import { DotIcon, TickCircleIcon } from 'common/components/core/icons';
import StackingLayout from 'common/components/core/StackingLayout/StackingLayout';
import TimeAgo from 'common/components/core/TimeAgo/TimeAgo';
import { NotificationStatusIcon } from 'common/components/NotificationsMenu/NotificationItem/NotificationStatusIcon/NotificationStatusIcon';
import type { NotificationSeverity } from 'common/components/NotificationsWidget/queries';
import type { TaskStatus } from 'common/components/TasksWidget/queries';
import { TaskStatusIcon } from 'Task/TaskStatusIcon/TaskStatusIcon';

import './TopBarDropdownMenuItem.scss';
import type { ItemOwnerProps } from './ItemOwner/ItemOwner';
import ItemOwner from './ItemOwner/ItemOwner';

export type TopBarDropdownMenuItemProps = {
  status?: TaskStatus;
  isNotification?: boolean;
  severity?: NotificationSeverity;
  time: string;
  content?: string | React.ReactNode;
  className?: string;
  handleItemClick?: () => void;
  onActionClick?: () => void;
  showAction?: boolean;
  owner?: ItemOwnerProps;
};

export default function TopBarDropdownMenuItem({
  content,
  time,
  className,
  handleItemClick,
  onActionClick,
  showAction,
  owner,
  status,
  isNotification,
  severity,
}: TopBarDropdownMenuItemProps) {
  const classNames = classnames('menu-item', className);
  const menuIcon = isNotification ? <NotificationStatusIcon severity={severity} /> : <TaskStatusIcon status={status} />;

  return (
    <>
      <StackingLayout className="width-100 m-0">
        <FlexLayout className={classNames}>
          <FlexLayout>
            <StackingLayout className="menu-item__icon">{menuIcon}</StackingLayout>
            <StackingLayout className="ml-xs" onClick={handleItemClick}>
              <StackingLayout className="m-0">{content}</StackingLayout>

              <FlexLayout className="mt-0" alignItems="center">
                {owner && (
                  <StackingLayout className="m-0">
                    <ItemOwner {...owner} />
                  </StackingLayout>
                )}
                <DotIcon className="menu-item__separator" />
                <StackingLayout className="ml-xs">
                  <TimeAgo to={new Date(time)} className="menu-item__time" addSuffix={true} />
                </StackingLayout>
              </FlexLayout>
            </StackingLayout>
          </FlexLayout>
          {showAction && (
            <Button
              label="Acknowledge"
              aria-label="Acknowledge"
              type={ButtonTypes.ICON_NAVIGATION}
              onClick={onActionClick}
            >
              <TickCircleIcon />
            </Button>
          )}
        </FlexLayout>
      </StackingLayout>
      <Divider appearance={DividerAppearance.NAVIGATION} className="m-0" />
    </>
  );
}
